import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonCheckbox } from '@ionic/angular';
import { OptionValue, SurveyLine } from 'src/app/models/survey-header.model';

@Component({
  selector: 'app-boolean-rating',
  templateUrl: './boolean-rating.component.html',
  styleUrls: ['./boolean-rating.component.scss'],
})
export class BooleanRatingComponent {

  @Input() question: SurveyLine

  @Input() rate = 0;

  @Output() didRated = new EventEmitter<number>();
  @Output() selectedOptions = new EventEmitter<string[]>();

  option: OptionValue;

  positiveOptions: OptionValue;
  negativeOptions: OptionValue;

  selectedOptionsValues: string[] = [];

  constructor() { }

  changeResponseStatus(status: string) {

    if (status === 'positive') {
      this.positiveOptions = this.question.positive_option_values;
      this.option = this.positiveOptions;
    } else if (status === 'negative') {
      this.negativeOptions = this.question.negative_option_values;
      this.option = this.negativeOptions;

    }
    this.selectedOptionsValues = [];
  }

  selectedOptionsChanged(option: string, type: string) {

    if (type === 'multiple') {
      if (this.selectedOptionsValues.includes(option)) {
        this.selectedOptionsValues = this.selectedOptionsValues.filter(x => x !== option);
      } else {
        this.selectedOptionsValues.push(option);
      }
    } else {
      this.selectedOptionsValues = [option];
    }

    this.selectedOptions.emit(this.selectedOptionsValues);

  }


}
